import { CuponesService } from './../../shared/service/cupones.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CouponsRoutingModule } from './coupons-routing.module';
import { ListCouponComponent } from './list-coupon/list-coupon.component';
import { CreateCouponComponent } from './create-coupon/create-coupon.component';
import { EditCouponComponent } from './list-coupon/edit-coupon/edit-coupon.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ListCouponComponent, CreateCouponComponent, EditCouponComponent],
  imports: [
    CommonModule,
    CouponsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule
  ], 
  providers: [
    CuponesService
  ]
})
export class CouponsModule { }
